<template>
  <div id="app">
    <c-c-comment />
    </div>
</template>

<script>
import CCComment from './components/Comment.vue'
  export default {
    name: "AppSe",
    components: {
      CCComment
    },  
    mounted:function(){
        // window.fbAsyncInit = function() {
        //   window.FB.init({
        //     appId            : '259719201765256',
        //     autoLogAppEvents : true,
        //     xfbml            : true,
        //     version          : 'v7.0',
        //     start: "set HTTPS=true&&react-scripts start"
        //   });
        //  };
      // 
     

    }
  }
</script>

      